// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as TailwindMerge from "tailwind-merge";
import * as TickIcon$LiteracyplanetTupperware from "../v2/TickIcon.res.mjs";
import * as CrossIcon$LiteracyplanetTupperware from "../v2/CrossIcon.res.mjs";
import * as V3MultiChoiceOptionContext$LiteracyplanetTupperware from "./V3MultiChoiceOptionContext.res.mjs";
import * as V3MultliChoiceStyleContext$LiteracyplanetTupperware from "./V3MultliChoiceStyleContext.res.mjs";

function PilotMultiChoiceOptionContainer$Radio(props) {
  var match = V3MultiChoiceOptionContext$LiteracyplanetTupperware.use();
  var marked = match.marked;
  var selected = match.selected;
  var onClickOption = match.onClickOption;
  var tmp;
  if (selected) {
    switch (marked) {
      case "Correct" :
          tmp = React.createElement(TickIcon$LiteracyplanetTupperware.make, {
                className: "w-5 h-5 fill-lpTick"
              });
          break;
      case "Wrong" :
          tmp = React.createElement(CrossIcon$LiteracyplanetTupperware.make, {
                className: "w-5 h-5 fill-lpCross"
              });
          break;
      case "Unanswered" :
          tmp = null;
          break;
      
    }
  } else {
    switch (marked) {
      case "Wrong" :
          tmp = React.createElement(TickIcon$LiteracyplanetTupperware.make, {
                className: "w-5 h-5 fill-lpTick"
              });
          break;
      case "Correct" :
      case "Unanswered" :
          tmp = null;
          break;
      
    }
  }
  return React.createElement("div", {
              className: TailwindMerge.twMerge("pilot-multi-choice-radio", selected && marked === "Correct" ? "lpTickPanel" : "", selected && marked === "Wrong" ? "lpCrossPanel" : ""),
              onClick: (function (param) {
                  onClickOption();
                })
            }, React.createElement("div", {
                  className: TailwindMerge.twMerge("border-2 border-[#0c9ce5] w-5 h-5 rounded-full", selected ? "bg-[#0c9ce5]" : "")
                }), props.children, React.createElement("div", undefined, tmp));
}

var Radio = {
  make: PilotMultiChoiceOptionContainer$Radio
};

function PilotMultiChoiceOptionContainer$RadioSets(props) {
  var match = V3MultiChoiceOptionContext$LiteracyplanetTupperware.use();
  var marked = match.marked;
  var selected = match.selected;
  var onClickOption = match.onClickOption;
  var tmp;
  var exit = 0;
  if (selected) {
    switch (marked) {
      case "Correct" :
          exit = 1;
          break;
      case "Wrong" :
          tmp = React.createElement("div", {
                className: "pilotClozeChoiceProviderMarkContainer"
              }, React.createElement(CrossIcon$LiteracyplanetTupperware.make, {
                    className: "pilotClozeChoiceProviderCrossSvg"
                  }));
          break;
      case "Unanswered" :
          tmp = null;
          break;
      
    }
  } else {
    switch (marked) {
      case "Wrong" :
          exit = 1;
          break;
      case "Correct" :
      case "Unanswered" :
          tmp = null;
          break;
      
    }
  }
  if (exit === 1) {
    tmp = React.createElement("div", {
          className: "pilotClozeChoiceProviderMarkContainer"
        }, React.createElement(TickIcon$LiteracyplanetTupperware.make, {
              className: "pilotClozeChoiceProviderTickSvg"
            }));
  }
  return React.createElement("button", {
              className: TailwindMerge.twMerge("pilot-multi-response-sets-radio", selected && marked === "Unanswered" ? "pilot-multi-response-sets-radio-selected" : "", !selected && marked === "Unanswered" ? "pilot-multi-response-sets-radio-unselected" : "", selected && marked === "Correct" ? "pilot-multi-response-sets-radio-correct" : "", selected && marked === "Wrong" ? "pilot-multi-response-sets-radio-wrong" : "", !selected && marked === "Wrong" ? "pilot-multi-response-sets-radio-unselected-wrong" : "", !selected && marked === "Correct" ? "pilot-multi-response-sets-radio-unselected-correct" : ""),
              onClick: (function (param) {
                  onClickOption();
                })
            }, tmp, props.children);
}

var RadioSets = {
  make: PilotMultiChoiceOptionContainer$RadioSets
};

function PilotMultiChoiceOptionContainer$Highlight(props) {
  var match = V3MultiChoiceOptionContext$LiteracyplanetTupperware.use();
  var showThisResponseAsCorrectAnswer = match.showThisResponseAsCorrectAnswer;
  var marked = match.marked;
  var selected = match.selected;
  var onClickOption = match.onClickOption;
  var tmp;
  if (showThisResponseAsCorrectAnswer !== undefined) {
    tmp = showThisResponseAsCorrectAnswer ? "lpTickPanel" : "cursor-pointer";
  } else if (selected) {
    switch (marked) {
      case "Correct" :
          tmp = "lpTickPanel";
          break;
      case "Wrong" :
          tmp = "lpCrossPanel";
          break;
      case "Unanswered" :
          tmp = "pilotHighlightWordSelected cursor-pointer";
          break;
      
    }
  } else {
    tmp = "cursor-pointer";
  }
  var tmp$1;
  var exit = 0;
  if (showThisResponseAsCorrectAnswer !== undefined) {
    if (showThisResponseAsCorrectAnswer) {
      exit = 1;
    } else {
      tmp$1 = null;
    }
  } else if (selected) {
    switch (marked) {
      case "Correct" :
          exit = 1;
          break;
      case "Wrong" :
          tmp$1 = React.createElement("div", {
                className: "pilotClozeChoiceProviderMarkContainer"
              }, React.createElement(CrossIcon$LiteracyplanetTupperware.make, {
                    className: "pilotClozeChoiceProviderCrossSvg"
                  }));
          break;
      case "Unanswered" :
          tmp$1 = null;
          break;
      
    }
  } else {
    tmp$1 = null;
  }
  if (exit === 1) {
    tmp$1 = React.createElement("div", {
          className: "pilotClozeChoiceProviderMarkContainer"
        }, React.createElement(TickIcon$LiteracyplanetTupperware.make, {
              className: "pilotClozeChoiceProviderTickSvg"
            }));
  }
  return React.createElement("span", {
              className: TailwindMerge.twMerge("pilotHighlightWord", tmp),
              onClick: (function (param) {
                  onClickOption();
                })
            }, props.children, tmp$1);
}

var $$Highlight = {
  make: PilotMultiChoiceOptionContainer$Highlight
};

function PilotMultiChoiceOptionContainer(props) {
  var children = props.children;
  var responseOptionId = props.responseOptionId;
  var kind = V3MultliChoiceStyleContext$LiteracyplanetTupperware.use();
  var tmp;
  tmp = typeof kind !== "object" ? (
      kind === "MultiChoiceRadio" ? React.createElement(PilotMultiChoiceOptionContainer$Radio, {
              children: children
            }) : React.createElement(PilotMultiChoiceOptionContainer$RadioSets, {
              children: children
            })
    ) : React.createElement(PilotMultiChoiceOptionContainer$Highlight, {
          responseOptionId: responseOptionId,
          children: children
        });
  return React.createElement(V3MultiChoiceOptionContext$LiteracyplanetTupperware.make, {
              group: props.group,
              questionIndex: props.questionIndex,
              responseOptionId: responseOptionId,
              children: tmp
            });
}

var make = PilotMultiChoiceOptionContainer;

export {
  Radio ,
  RadioSets ,
  $$Highlight ,
  make ,
}
/* react Not a pure module */
